var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "row" }, [
    !_setup.selectedPod
      ? _c(
          "div",
          { staticClass: "col-12" },
          [_c(_setup.PodSelector, { on: { select: _setup.podSelected } })],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _setup.podComponentName && _setup.filteredTemplateProductConfiguration
      ? _c("div", { staticClass: "col-12" }, [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_setup.savingVariants,
                  expression: "!savingVariants",
                },
              ],
            },
            [
              _c(_setup.podComponentName, {
                tag: "component",
                attrs: {
                  store: _setup.storeUrl,
                  "initial-configuration":
                    _setup.filteredTemplateProductConfiguration,
                },
                on: { save: _setup.onConfigurationSaved },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _setup.savingVariants
            ? _c(
                "div",
                {
                  staticClass:
                    "col-12 align-items-center d-flex flex-column justify-content-center p-4",
                },
                [
                  _c("b-spinner", {
                    staticClass: "mr-2",
                    attrs: { variant: "primary" },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "mt-2" }, [
                    _vm._v("Saving configuration"),
                  ]),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "col-12 text-center mb-3 mt-3",
              staticStyle: { color: "red" },
            },
            [_c("b", [_vm._v(_vm._s(_setup.errorMessage))])]
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    _setup.selectedPod && !_setup.savingVariants
      ? _c("div", { staticClass: "col-12" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-secondary float-left",
              on: { click: _setup.goToPodSelection },
            },
            [_vm._v("Go to POD selection")]
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }